export var ConfigureViewType;
(function (ConfigureViewType) {
    ConfigureViewType[ConfigureViewType["Web"] = 0] = "Web";
    ConfigureViewType[ConfigureViewType["Mobile"] = 1] = "Mobile";
    ConfigureViewType[ConfigureViewType["Thumbnail"] = 2] = "Thumbnail";
    ConfigureViewType[ConfigureViewType["PopView"] = 3] = "PopView";
})(ConfigureViewType || (ConfigureViewType = {}));
